<template>
  <div id="app">
    <!-- 顶部导航 -->
    <div class="nav bgWhite" :class="{shadow:isNotHome,_nav:!$global.isPc}">
        <div class="container-main flex flexalign flexbetween height1001">
            <div class="flex flexalign" style="margin-right: 20px;">
                <img :src="logo" height="50" v-if="!this.$global.isPc" />
                <img :src="logo" height="50" class="diannao" v-else/>
            </div>
            <!--    电脑端    -->
            <div class="flex" v-if="this.$global.isPc">
                <div class="nav-item position-rela" :class="{active:path==item.path,navItemAfter:item.childs}" v-for="(item,index) in navList" :key="index" v-if="!item.isnotshow" @click="clickNav(item)">
                    <div>{{ item.name }}</div>
                    <div class="position-abso item-child-main" v-if="item.childs">
                        <div class="item-child" v-for="(item_child,index_child) in item.childs" :key="index_child" @click="clickNav(item_child)">
                          <div>{{ item_child.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!--    移动端    -->
            <div v-else class="icon-caidansangehengxian" @click="clickCloseShowHome()"></div>
            <div class="text-left showhome-nav" v-if="showhome">
                <div class="flex flexalign flexbetween height70 container-main">
                  <img class="phone-logo" :src="logo" height="50" />
                  <div class="icon-quxiao" @click="clickCloseShowHome()"></div>
                </div>
                <div class="con">
                    <div class="position-rela" :class="{activem:path==item.path}" v-for="(item,index) in navList" :key="index" v-if="!item.isnotshow" @click="clickNav(item)">
                        <div>{{ item.name }}</div>
                        <div class="position-abso margin-top10" v-if="item.childs">
                          <div class="item-child" v-for="(item_child,index_child) in item.childs" :key="index_child" @click="clickNav(item_child)">
                              <div>{{ item_child.name }}</div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-view/>
    <!-- 联系我们 -->
    <div class="bgf2 padding20-0 color6c757d">
        <div class="container-main" :class="{_foot_container_main:!$global.isPc}">
            <div class="flex flexbetween flexalign width1001" :class="{_flex:!$global.isPc}">
                <div class="flex text-left width1001 line-height26 fontsize14" :class="{_flex:!$global.isPc}">
                        <div class="width501" :class="{_foot_width501:!$global.isPc}">
                            <div class="font-size-18">{{footer_info.company_name}}</div>
                            <div>营业执照：{{footer_info.business_license}}</div>
                            <div><a href="https://beian.miit.gov.cn/">备案号码：{{footer_info.beian}}</a></div>
                            <div>地址：{{footer_info.address}}</div>
                        </div>
                        <div class="width501" :class="{_foot_width501:!$global.isPc,marginTop10:!$global.isPc}">
                            <div class="font-size-18">联系我们</div>
                            <div>电话：{{footer_info.mobile}}</div>
                            <div>邮箱：{{footer_info.email}}</div>
                            <div>Q  Q：{{footer_info.qq}}</div>
                        </div>
                </div>    
                <div :class="{displayNone:!$global.isPc}">
                    <img :src="footer_info.customer_image" width="100" height="100"/>
                    <div class="font-size-10">扫一扫 手机访问</div>
                </div>
            </div>
        </div>
    </div>
               
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      showhome:false,
      lang:1,
      logo:require('./assets/logo.jpg'),
      bottom_image: require('./assets/logo.jpg'),
      path:'/',
      clickId:null,
      ishref: false,
      navList:[],
      footer_info:'',
      isVisable: false,
      isNotHome: false
    }
  },
  created(){
    this.navList = this.$global.menu
    this.init()
    //在窗口滚动时调用监听窗口滚动方法
    this.$nextTick(() => {
      // window.addEventListener('scroll', this.windowScrollListener, true);
    })
    this.$router.afterEach((to,from)=>{
      this.path = to.fullPath.split('?')[0]
      if(to.fullPath != '/'){
          this.isNotHome = true;
          this.isVisable = true; 
      }else{
          this.isNotHome = false;
          // this.windowScrollListener()
      }
    })
    this.path = this.$global.path
  },
  methods:{
      clickCloseShowHome(){
          this.showhome = !this.showhome
      },
    init(){
      let lang = localStorage.getItem('lang')
      if(lang && lang !== 'null') this.lang = lang
      else localStorage.setItem('lang',this.lang)
      this.$global.lang = this.lang
      this.$http.defaults.headers.Language = this.lang
      // console.log(this.$global.lang,'切换语言') 
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        this.$global.isPc = false
      } else {
        this.$global.isPc = true
      }
      let that = this
      this.$http.get('/api/index/getconfig').then(
        res => {
          that.footer_info = res.data.data
        },
        error=>{}
      )
    },
    clickNav(item){
      if(this.ishref || item.childs || this.$route.path==item.path) return;
      this.ishref = true;
      this.$global.path = item.path
      if(item.path != this.path){
        let p = item.path.replace('/','')
        if(p.length>0){
          this.$router.push({name:p,query:{scode:item.query.scode}})
        }else{
          this.$router.push('/')
        }
        this.path = item.path
      }
      this.ishref = false;
      if(this.showhome) this.showhome = !this.showhome
    }
  }

}
</script>

<style>
body{margin: 0px !important;}
#app {
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212529;
}
/* background: #187AB0; */
.a-main{margin-top: 70px;}
.nav{position: fixed;top: 0;left: 0;width: 100% !important;z-index: 99;color: rgba(0, 0, 0, .5);height: 70px;line-height: 70px;font-size: 14px;border-bottom: 1px solid #e6e6e6}
.nav.shadow{box-shadow: 1px 1px 2px #f5f5f5}
.nav .nav-item{cursor: pointer;margin: 0 10px;}
.nav .active{color: rgba(0, 0, 0, .9);}
.nav .activem{color: rgba(0, 0, 0, .9);}
._nav{line-height: 32px !important;}
.font-size-42{font-size: 42px !important;}
.font-size-30{font-size: 30px;}
.font-size-24{font-size: 24px !important;}
.font-size-20{font-size: 20px !important;}
.font-size-18{font-size: 18px !important;}
.font-size-14{font-size: 14px !important;}
.fontsize14{font-size: 14px;}
.font-size-10{font-size: 10px !important;}
.font-weight{font-weight: 600;}
.text-left{text-align: left;}
.position-rela{position: relative;}
.position-abso{position: absolute;}
.right10{right: 10px}
.top{top: 0}
.top10{top: 10px}
.top-center{top: 50%;transform: translateY(-50%);}
.color-white{color: #fff;}
.bottom-0{bottom: 0;}
.bottom-5{bottom: 5px;}
.left-center{left: 50%;transform: translateX(-50%);}
.text-center{text-align: center;}
.text-right{text-align: right;}
.showhome-nav{position: fixed;top: 0;bottom: 0;left: 0;right: 0;background: #fff;}
.showhome-nav .con{width: 80%;margin: 10px auto}
.showhome-nav .con>div{margin-top: 10px;border-bottom: 1px solid rgba(0, 0, 0, .15);}
.overflow{overflow: hidden;}
.flex{display: flex;}
.flexwrap{flex-wrap: wrap;}
.flexalign{align-items: center;}
.flexjust{justify-content: center;}
.flexbetween{justify-content: space-between;}
.flex-1,.flex1{flex: 1;}
.padding-left10{padding-left: 10px;}
.padding-left15{padding-left: 15px;}
.padding-bottom40{padding-bottom: 40px;}
.padding-bottom15{padding-bottom: 15px;}
.padding0-15{padding:0 15px;}
.padding10{padding: 10px;}
.padding10-0{padding: 10px 0;}
.padding20-0{padding: 20px 0;}
.padding40-0{padding: 40px 0;}
.padding80-0{padding: 80px 0;}
.padding01{padding: 1%;}
/* .padding01:nth-child(2n+1){padding-right: 0.5%;}
.padding01:nth-child(2n){padding-left: 0.5%;} */
.margin-right5{margin-right: 5px;}
.margin-left5{margin-left: 5px;}
.margin-left10{margin-left: 10px;}
.margin-left20{margin-left: 20px;}
.margin-top5{margin-top: 5px;}
.margin-top10,.marginTop10{margin-top: 10px;}
.margin-top20{margin-top: 20px;}
.margin-top40{margin-top: 40px;}
.margin-top-4{margin-top: -4px;}
.margin0-15{margin: 0 15px;}
.margin415{margin: 15px;}
.margin10-0{margin: 10px 0;}
.margin20-0{margin: 20px 0;}
.margin30-0{margin: 30px 0;}
.margin40-0{margin: 40px 0;}
.margin-bottom-4{margin-bottom: -4px;}
.img{width: 100%;height: 100%;object-fit: cover;cursor: pointer;}
.img-qrcode{width: 100px;height: 100px;}
.cursor{cursor: pointer;}
._bg{background: #187AB0;color: #fff}
.bgWhite{background: #fff}
.bgf2{background: #f2f2f2;}
.prewrap{white-space: pre-wrap;}
.colorddd{color: #dddddd !important;}
.color6c757d{color: #6c757d;}
.colorsuccess{color: #28a745;}
.color999{color: #999999;}
.border{border: 1px solid rgba(0,0,0,.125)}
.border-bottom{border-bottom: 1px solid rgba(0,0,0,.125)}
.border-top{border-top: 1px solid rgba(0,0,0,.125)}
.multi-line-ellipsis{
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.multi-line-ellipsis-4{-webkit-line-clamp: 4 !important;}
.display-block{display: block;}
.displayNone{display: none;}
.line-height26{line-height: 26px;}
.more{text-align: center;color: rgba(0, 0, 0, .5);cursor: pointer;}
.overflow{overflow: hidden;}
.width251{width: 25%;}
.width251-4{width: calc(25% - 33px);}
.width501{width: 50%;}
.width1001{width: 100%;}
.height1001{height: 100%;}
.foot-height{height: 220px;}
.heightepc {height: 150px;}
.height70 {height: 70px;}
.item-child-main{padding: 10px 0;background: #ffffff;border: 1px solid rgba(0, 0, 0, .15);border-radius: 2px;display: none;color: rgba(0, 0, 0, .5);;}
.item-child{line-height: 30px !important;padding: 0 10px;width: 100px;}
.item-child:hover{color: rgba(0, 0, 0, .9);}
.nav-item:hover .item-child-main{display: block;}
.navItemAfter::after{content: '';position: absolute;right: -14px;top: 51%;transform: translateY(-50%);width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid rgba(0, 0, 0, .5);}
.nav-item:hover{color: rgba(0, 0, 0, .9);}
.animate-element{animation: grow 1s ease-out ;}
.line2{line-height:2;}
@keyframes grow {
  from {
    transform: scale(0); /* 动画开始时，元素的大小为0 */
  }
  to {
    transform: scale(1); /* 动画结束时，元素的大小恢复为1 */
  }
}
.animate-element-down{animation: slideDown 2s forwards;}
@keyframes slideDown {
  0% {
    transform: translateY(-40px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-element-up{animation: slideUp 2s forwards;}
@keyframes slideUp {
  0% {
    transform: translateY(40px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.href-color:hover{color: #187AB0;}
.icon-caidansangehengxian{
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  background-repeat: no-repeat;background-size: cover;
  width: 40px;
  height: 40px;
}
.icon-quxiao{
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  background-repeat: no-repeat;background-size: cover;
  width: 40px;
  height: 40px;
}
._foot_width501{width: 100% !important;}
._foot_container_main{width: 90% !important;}
img{vertical-align: middle;border-style: none;}
.container-main-info img{max-width: 100% !important;}
.container-main-info video{max-width: 100% !important;}


.container{margin-top: 70px;width: 100%;}
.container-main{width: 70%;margin: 0 auto;}
@media (max-width: 1300px){
  .padding40-0{padding: 20px 0 !important;}
}
@media (max-width: 1200px){
  .padding40-0{padding: 10px 0 !important;}
  .container-main{width: 80%;}
}
@media (max-width: 992px) {
  ._flex{flex-wrap: wrap;}
  ._width251{width: calc(50% - 32px) !important;margin: 10px !important;}
  .container-main{width: 90%;}
  .nav .nav-item{margin: 0 5px;}
  .diannao{height: 40px;}
}
@media (max-width: 830px) {
    .nav .nav-item{margin: 0 2px;}
}
@media (max-width: 768px){
  .container-main{width: 98%;}
  .swiper-button-next{display: none;}
  .swiper-button-prev{display: none;}
  .padding20-0{padding: 5px 0;}
  .padding80-0{padding: 30px 0;}
}
@media (max-width: 576px){
  ._width251{width: 100% !important;margin: 10px !important;}
  .service-img{width: 50px;height: 50px;}
}
</style>
